import { useEffect, useState } from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Nav } from "./Nav";
import { Text } from "./Text";
import { MoreButton } from "./MoreButton";
import { HashLink } from "react-router-hash-link";

export const Header = () => {
  const [menuShow, setMenuShow] = useState<boolean>(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const location = useLocation();
  useEffect(() => {
    if (menuShow) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
    }
  }, [menuShow]);

  useEffect(() => {
    setMenuShow(false);
  }, [location.pathname, location.hash]);
  return (
    <header
      style={{
        borderTop: "8px solid #006400",
        position: location.pathname === "/" ? "relative" : "sticky",
        top: 0,
        left: 0,
        zIndex: 100,
        background: location.pathname === "/" ? "unset" : "#fff",
      }}
    >
      {location.pathname === "/" ? null : <Nav />}

      {isMobile ? (
        <Stack
          position="fixed"
          top={0}
          right={0}
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={45}
          height={45}
          zIndex={101}
          sx={{
            background: "rgba(0,100,0,1)",
          }}
          onClick={() => setMenuShow(!menuShow)}
        >
          <Stack
            sx={{
              position: "relative",
              width: "22px",
              height: "3px",
              borderRadius: 999,
              background: menuShow ? "rgba(0,100,0,1)" : "#fff",
              transition: "background 0.3s ease",
              "&::before, &::after": {
                content: "''",
                position: "absolute",
                display: "block",
                width: "22px",
                height: "3px",
                borderRadius: 999,
                background: "#fff",
                left: "50%",
                transform: "translateX(-50%)",
                transition: "top 0.3s ease, transform 0.3s ease",
              },
              "&::before": {
                top: menuShow ? "0px" : "-8px",
                transform: menuShow
                  ? "translateX(-50%) rotate(45deg)"
                  : "translateX(-50%)",
              },
              "&::after": {
                top: menuShow ? "0px" : "8px",
                transform: menuShow
                  ? "translateX(-50%) rotate(-45deg)"
                  : "translateX(-50%)",
              },
            }}
          ></Stack>
        </Stack>
      ) : null}

      {isMobile ? (
        <Stack
          position="absolute"
          top="0"
          right={menuShow ? 0 : "-100%"}
          width="100%"
          maxWidth="320px"
          height="100vh"
          zIndex={100}
          sx={{
            background: "rgba(0,100,0,0.85)",
            transition: "right 0.3s ease",
          }}
        >
          <Stack sx={{ padding: "13px 22px 50px", overflowY: "scroll" }}>
            <Stack width={130}>
              <HashLink onClick={() => setMenuShow(false)} smooth to="/">
                <img
                  src="/images/logo.png"
                  alt=""
                  style={{
                    width: "100%",
                  }}
                />
              </HashLink>
            </Stack>
            <Stack marginTop={2.8}>
              <HashLink onClick={() => setMenuShow(false)} smooth to="/fungi">
                <Text color="#fff" fontSize={12} fontWeight={700}>
                  About Fungi
                </Text>
              </HashLink>
              <Stack>
                <HashLink
                  onClick={() => setMenuShow(false)}
                  smooth
                  to="/fungi#1"
                >
                  <Text color="#fff" fontSize={12} marginTop={1.6}>
                    - 真菌とは
                  </Text>
                </HashLink>
              </Stack>
              <Stack>
                <HashLink
                  onClick={() => setMenuShow(false)}
                  smooth
                  to="/fungi#2"
                >
                  <Text color="#fff" fontSize={12} marginTop={1.6}>
                    - ゲノム編集
                  </Text>
                </HashLink>
              </Stack>
              <Stack>
                <HashLink
                  onClick={() => setMenuShow(false)}
                  smooth
                  to="/fungi#3"
                >
                  <Text color="#fff" fontSize={12} marginTop={1.6}>
                    - 産業的活用
                  </Text>
                </HashLink>
              </Stack>
              <Stack>
                <HashLink
                  onClick={() => setMenuShow(false)}
                  smooth
                  to="/fungi#4"
                >
                  <Text color="#fff" fontSize={12} marginTop={1.6}>
                    - 当社ターゲット
                  </Text>
                </HashLink>
              </Stack>
            </Stack>
            <Stack marginTop={2.8}>
              <HashLink
                onClick={() => setMenuShow(false)}
                smooth
                to="/technology"
              >
                <Text color="#fff" fontSize={12} fontWeight={700}>
                  Technology
                </Text>
              </HashLink>
              <Stack>
                <HashLink
                  onClick={() => setMenuShow(false)}
                  smooth
                  to="/technology#1"
                >
                  <Text color="#fff" fontSize={12} marginTop={1.6}>
                    - 細胞内で自律的に複製可能なベクター
                  </Text>
                </HashLink>
              </Stack>
              <Stack>
                <HashLink
                  onClick={() => setMenuShow(false)}
                  smooth
                  to="/technology#2"
                >
                  <Text color="#fff" fontSize={12} marginTop={1.6}>
                    - 純国産のCRISPRフリーゲノム編集ツール
                  </Text>
                </HashLink>
              </Stack>
              <Stack>
                <HashLink
                  onClick={() => setMenuShow(false)}
                  smooth
                  to="/technology#3"
                >
                  <Text color="#fff" fontSize={12} marginTop={1.6}>
                    - 微生物特化型のゲノム編集手法
                  </Text>
                </HashLink>
              </Stack>
              <Stack>
                <HashLink
                  onClick={() => setMenuShow(false)}
                  smooth
                  to="/technology#4"
                >
                  <Text color="#fff" fontSize={12} marginTop={1.6}>
                    - 無性的なゲノム交雑の促進
                  </Text>
                </HashLink>
              </Stack>
            </Stack>
            <Stack marginTop={2.8}>
              <HashLink onClick={() => setMenuShow(false)} smooth to="/service">
                <Text color="#fff" fontSize={12} fontWeight={700}>
                  Services
                </Text>
              </HashLink>
            </Stack>
            <Stack marginTop={1.5}>
              <HashLink onClick={() => setMenuShow(false)} smooth to="/news">
                <Text color="#fff" fontSize={12} fontWeight={700}>
                  News
                </Text>
              </HashLink>
            </Stack>
            <Stack marginTop={1.5}>
              <HashLink onClick={() => setMenuShow(false)} smooth to="/company">
                <Text color="#fff" fontSize={12} fontWeight={700}>
                  Company
                </Text>
              </HashLink>
            </Stack>
            <Stack marginTop={2.8} onClick={() => setMenuShow(false)}>
              <MoreButton
                href="/contact"
                width={275}
                right={45}
                color="secondary"
              >
                <Text color="#fff">Contact Us</Text>
              </MoreButton>
            </Stack>
          </Stack>
        </Stack>
      ) : null}
    </header>
  );
};
